import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Crown, Loader2, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/admin");
    else setError(res.error);
  };

  return (
    <div className="hero-radial flex min-h-screen items-center justify-center px-4">
      <form onSubmit={submit} className="w-full max-w-sm rounded-2xl border border-gold/20 bg-obsidian-card p-8 gold-glow" data-testid="admin-login-form">
        <div className="mb-6 flex flex-col items-center text-center">
          <span className="flex h-14 w-14 items-center justify-center rounded-2xl gold-gradient">
            <Crown className="h-7 w-7 text-obsidian" />
          </span>
          <h1 className="mt-4 font-display text-2xl font-bold gold-text">Golden Live Admin</h1>
          <p className="mt-1 text-sm text-slate-400">Sign in to manage your website</p>
        </div>

        {error && <p className="mb-4 rounded-lg bg-red-500/10 px-3 py-2 text-sm text-red-400" data-testid="admin-login-error">{error}</p>}

        <label className="mb-1.5 block text-sm font-medium text-slate-300">Email</label>
        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
          data-testid="admin-login-email"
          className="mb-4 h-11 w-full rounded-lg border border-gold/20 bg-obsidian px-3 text-slate-100 outline-none focus:border-gold/60" />

        <label className="mb-1.5 block text-sm font-medium text-slate-300">Password</label>
        <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
          data-testid="admin-login-password"
          className="mb-6 h-11 w-full rounded-lg border border-gold/20 bg-obsidian px-3 text-slate-100 outline-none focus:border-gold/60" />

        <button type="submit" disabled={loading} data-testid="admin-login-button"
          className="flex h-12 w-full items-center justify-center gap-2 rounded-lg gold-gradient font-bold text-obsidian transition-transform hover:scale-[1.02] disabled:opacity-50">
          {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : <Lock className="h-5 w-5" />}
          {loading ? "Signing in..." : "Sign In"}
        </button>
      </form>
    </div>
  );
}
